// Ensures the Google Maps JS SDK is loaded exactly once, even if called
// concurrently from multiple components.

let loadPromise: Promise<void> | null = null;

export function loadGoogleMapsScript(): Promise<void> {
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY ?? "";

  // Already loaded
  if (typeof window !== "undefined" && window.google?.maps) {
    return Promise.resolve();
  }

  // Load already in progress — reuse the same promise
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null; // allow retry on next call
      reject(new Error("Failed to load Google Maps script"));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
}
